<template>
  <div class="v3-popup lottery-succ-popup">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div
      class="v3-popup-content"
      :class="{
        large: lotteryResult.length > 1,
        succ: lotteryResult.length == 1,
      }"
    >
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title"></div>
      <div class="v3-popup-content-content">
        <div class="lottery-result-list">
          <div
            class="lottery-result-item"
            v-for="(item, index) in lotteryResult"
            :key="`${item.awardVtId}-${index}`"
          >
            <div class="award-icon-box">
              <div class="award-icon" :class="`award-${item.awardId}`"></div>
            </div>
            <div class="lottery-result-item-title">
              {{ awardConfig[item.awardId] || item.awardName }}
            </div>
          </div>
        </div>
      </div>
      <div class="v3-popup-content-footer">
        <div class="confirm-btn btns" @click="handleClose"></div>
        <div class="lottery-tips">※版本更新後，請返回活動頁領取禮包碼</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, ref, watch } from "vue";
import { point } from "@/utils";

import LanguageHook from "@hooks/language";
import { awardConfig } from "@/config";
// 语言相关
const { langData } = LanguageHook();

const v3PopupState = inject("v3PopupState");
const lotteryResult = inject("lotteryResult", ref([]));

// 监听弹窗状态，打点上报
watch(
  () => v3PopupState.lotterySuccPopupState,
  (value) => {
    if (value) {
      point({
        eventName: 'show_popup',
        eventType: '抽奖成功弹窗'
      });
    }
  }
);

const handleClose = () => {
  v3PopupState.lotterySuccPopupState = false;
  lotteryResult.value = [];
};
</script>

<style scoped lang="less"></style>
